<template>
  <div class="row">
    <div>
      <api-header id="title" tag="h1">
        {{ info.title }}
        <VBadge
          v-if="info.badge"
          :text="info.badge"
          connotation="cta"
          shape="pill"
          :appearance="isVonageBrand ? 'subtle' : 'duotone'"
          class="pill large ml-4"
        />
      </api-header>
      <api-version-selector :versions="info.versions" />
      <api-note v-if="info.note" :note="info.note" />
      <html-text tag="span" :html="info.description" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { VBadge } from '@vonage/vivid-vue';
import { InfoObject } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import HtmlText from '@/components/utils/HtmlText.vue';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import ApiVersionSelector from '@/components/api/content/common/ApiVersionSelector.vue';
import ApiNote from '@/components/api/content/common/ApiNote.vue';
import { isVonageBrand } from '@/constants';

defineProps({
  info: { type: Object as PropType<InfoObject>, required: true },
});
</script>
